export default __webpack_public_path__ + "static/media/state-1.cd68540d.jpg";